/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicServiceImpactAnalysis extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicServiceImpactAnalysis");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicServiceImpactAnalysis.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicServiceImpactAnalysis>): BackgroundJobPayloadForPeriodicServiceImpactAnalysis {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicServiceImpactAnalysis(), model);
        BackgroundJobPayloadForPeriodicServiceImpactAnalysis.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicServiceImpactAnalysis>): BackgroundJobPayloadForPeriodicServiceImpactAnalysis {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicServiceImpactAnalysis.newInstance(<BackgroundJobPayloadForPeriodicServiceImpactAnalysis> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicServiceImpactAnalysis) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicServiceImpactAnalysis.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicServiceImpactAnalysis): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicServiceImpactAnalysis.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
